import { Component, NgZone, OnInit, OnDestroy } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ajax } from "jquery";
import {
  AppUI,
  AsThreshold,
  Base64,
  FaceSDK,
  FaceSdkOptionsType,
  PrecaptureChecks,
  SdkOptionsType,
  Template,
  TransactionMode,
  VideoSelfieSDK,
  VideoSelfieSdkOptionsType,
  VideoSelfieResult,
  VideoSelfiePhase2Layout,
} from "@identy/identy-face";
import { ContextMenuHelperService } from "../title-bar/title-context-menu/context-menu-helper.service";
import { ProgressDialogComponent } from "../dialogs/progress-dialog/progress-dialog.component";
import { TransactionDialogComponent } from "../dialogs/transaction-dialog/transaction-dialog.component";
import { ZipModule } from "src/app/modules/zip-module";
import { saveAs } from "file-saver";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import { UserInputComponent } from "../dialogs/user-input/user-input.component";
import { MatDialog } from "@angular/material/dialog";
import { CameraInputComponent } from "../dialogs/camera-input/camera-input.component";
import { ErrorMessageService } from "../../modules/helpers/error-message.service";
import { UserMeta } from "../../modules/models/types";
import { MetaServiceService } from "../../modules/helpers/meta-service.service";
import { MenuConfigService } from "../../services/menu-config.service";
import { Subscription } from "rxjs";
//@ts-ignore
import * as splash_png from "../../../assets/images/face_app_icon.png";
declare var WURFL: any;

@Component({
  selector: "app-sdk-run",
  templateUrl: "./sdk-run.component.html",
  styleUrls: ["./sdk-run.component.css"],
})
export class SdkRunComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private context_menu_service: ContextMenuHelperService,
    private zone: NgZone,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private error_message: ErrorMessageService,
    private meta_service: MetaServiceService,
    private menuConfigService: MenuConfigService,
    private http: HttpClient,
  ) {}

  action: string;
  redirect: string;
  active: boolean;
  allow_capture: boolean = true;
  isLocalhost = window["isTest"]
    ? false
    : window.location.origin.includes("localhost");
  username: UserMeta = null;

  public readonly splash_png = splash_png["default"];
  public readonly faceOnly = environment["faceOnly"] || false;

  update_menu_based_on_checks(strict: boolean) {
    const func = strict
      ? FaceSDK.get_strict_pipeline_default_checks()
      : FaceSDK.get_relaxed_pipeline_default_checks();

    func.then((map: Map<string, boolean>) => {
      this.context_menu_service.menuValues.icao_threshold = map;

      const selectedChecks = Array.from(map.entries())
        .filter(([_, v]) => v)
        .map(([k]) => PrecaptureChecks[k]);

      this.menuConfigService.updateDefaultValue(
        "ICAO PreChecks",
        "icao_threshold_ui",
        selectedChecks,
      );
      this.menuConfigService.updateDefaultValue(
        "ICAO PreChecks",
        "icao_strict",
        strict,
      );
    });
  }

  ngOnInit() {
    try {
      this.subscriptions.push(
        this.menuConfigService.onFieldChange("icao_strict", (icao_strict) => {
          this.update_menu_based_on_checks(icao_strict);
        }),
      );

      this.subscriptions.push(
        this.menuConfigService.onFieldChange(
          "icao_threshold_ui",
          (icao_strict) => {
            const valz = new Map<string, boolean>();
            Object.keys(icao_strict).forEach((k) =>
              valz.set(k, icao_strict[k]),
            );
            this.context_menu_service.menuValues.icao_threshold = valz;
          },
        ),
      );

      this.getUser().then((username: UserMeta) => {
        this.username = username;
        const userId =
          (username || "default") + ":" + WURFL.complete_device_name;

        if (!this.isLocalhost) {
          console.log("Recording Web.......");
          //@ts-ignore
          if (window["LogRocket"]) {
            // window['LogRocket'].identify({
            //   userID: userId,
            // })
          }
        }
        this.meta_service.run_uploads(username);
      });
    } catch (e) {
      console.log(e);
    }

    this.action = this.route.snapshot.queryParamMap.get("action");
    this.redirect = this.route.snapshot.queryParamMap.get("redirect");
    if (this.action === "CAPTURE") {
      setTimeout(() => {
        this.runTransaction();
      }, 100);
    }

    window.addEventListener("identy_face_sdk_populated", (event) => {
      this.update_menu_based_on_checks(false);
    });
  }

  getUser() {
    return new Promise<UserMeta>((resolve) => {
      if (this.username) {
        return resolve(this.username);
      }
      console.log("User rendering");
      this.dialog.open(UserInputComponent, {
        data: {
          onclose: (username: UserMeta) => {
            console.log(`Username: ${JSON.stringify(username)}`);
            resolve(username);
          },
        },
        disableClose: true,
      });
    });
  }

  async runTransaction() {
    const options: FaceSdkOptionsType = {
      enableDF: this.context_menu_service.menuValues.enable_df,
      dfThreshold: this.context_menu_service.menuValues.df_threshold,
      enableAS: this.context_menu_service.menuValues.enable_as,
      requiredTemplates: this.context_menu_service.menuValues.templates,
      showCaptureTraining:
        this.context_menu_service.menuValues.capture_training,
      base64EncodingFlag: Base64.NO_WRAP,
      allowClose: true,
      enableEyesStatusDetector:
        this.context_menu_service.menuValues.enable_eye_status,
      skipSupportCheck: this.context_menu_service.menuValues.skip_device_check,
      localization: this.context_menu_service.menuValues.localization,
      allowUnknownBrowsers: [
        { name: "Instagram", version: 250 },
        { name: "TikTok", version: 21 },
      ],
      transaction: {
        type: TransactionMode.CAPTURE,
      },
      graphics: {
        canvas: {
          canvasBackground: "#ffffff",
          canvasBackgroundAssisted: "#ffffff63",
          ovalBorderBackground: "#00409E",
          ovalBorderErrorBackground: "#00409E",
          tickerDefaultBackground: "#ded9d9",
          tickerActiveBackground: "#00409E",
        },
      },
      appUI: this.context_menu_service.menuValues.app_ui,
      allowCameraSelect:
        this.context_menu_service.menuValues.allow_camera_select,
      asThreshold: this.context_menu_service.menuValues.as_threshold,
      assisted: this.context_menu_service.menuValues.assisted,
      enableRetakeScreen: this.context_menu_service.menuValues.enable_retake,
      enableBackgroundRemoval:
        this.context_menu_service.menuValues.enableBackgroundRemoval,
      backgroundColor: this.context_menu_service.menuValues.backgroundColor,
      captureTimeout: this.context_menu_service.menuValues.timeout * 1000,
      enableICAOChecks: this.context_menu_service.menuValues.enable_icao_checks,
      precaptureCheck: this.context_menu_service.menuValues.icao_strict,
      precaptureOptions: this.context_menu_service.menuValues.icao_threshold,
      events: {
        onImageQualityDetected: (quality: any) => {
          console.log(JSON.stringify(quality));
        },
        onInputDevicesDetected: (devices: any) => {
          return new Promise<unknown>((resolve, reject) => {
            this.zone.run(() => {
              const modal_cam_ref = this.dialog.open(CameraInputComponent, {
                data: {
                  devices: devices,
                  onclose: (device: MediaDeviceInfo) => {
                    modal_cam_ref.close();
                    setTimeout(() => {
                      resolve(device.deviceId);
                    }, 100);
                  },
                },
                disableClose: true,
              });
            });
          });
        },
      },
    };

    // not exposed field just for testing
    options["returnQualityMetadata"] = true;
    options["enableGImage"] = true;

    const faceSDK = new FaceSDK(options);
    this.allow_capture = false;
    return faceSDK
      .initialize()
      .then(() => {
        this.active = true;
        return faceSDK.capture().then((blob: Blob) => {
          return this.postData(faceSDK, blob);
        });
      })
      .catch((err) => {
        console.log(err);
        const m = err && err["getLocalizedString"];
        if (m) {
          if ([100, 104, 103, 500, 202, 501, 101].includes(err.code)) {
            alert(err.getLocalizedString());
          }
          if (err.code === 600) {
            const clientResponse = {
              code: err.code,
              feedback_code: err.message,
            };
            const modal_txn_ref = this.dialog.open(TransactionDialogComponent, {
              data: {
                data: clientResponse,
                options: options,
                onclose: () => {
                  modal_txn_ref.close();
                },
                onretry: () => {
                  modal_txn_ref.close();
                  this.capture();
                },
              },
            });
          }
        }
      })
      .finally(() => {
        this.allow_capture = true;
        this.active = false;
      });
  }

  private processBlob(blob: Blob): Promise<any> {
    const install = JSON.parse(localStorage.getItem("FACE_IM")) as any;
    const form_data = new FormData();
    form_data.append("file", blob, "bdata");
    form_data.append(
      "capture_meta",
      JSON.stringify({
        metadata_by_user_key: this.username.unique_user_id,
        metadata_by_mobile_device_key: install["unique_installation_id"],
        timestamp: new Date().getTime(),
      }),
    );
    return new Promise<any>((resolve, reject) => {
      ajax({
        url: `${environment.url_processing}/api/v1/process?ts=${new Date().getTime()}`,
        contentType: false,
        processData: false,
        method: "POST",
        dataType: "JSON",
        headers: {
          "X-DEBUG": this.username.unique_user_id,
        },
        data: form_data,
      })
        .done((response) => {
          if (response.code !== 200) {
            reject(response);
          }
          resolve(response);
        })
        .fail(reject);
    });
  }

  async postData(sdk: FaceSDK, capresult: Blob) {
    this.allow_capture = true;
    this.dialog.open(ProgressDialogComponent, {
      disableClose: true,
      data: {
        message: "Uploading...",
      },
    });

    return this.processBlob(capresult)
      .then((response: any) => {
        console.log(response);
        this.dialog.closeAll();

        if (this.action && this.redirect) {
          window.location.assign(this.redirect);
          return;
        }

        const jsonresponse = response;
        console.log(jsonresponse);
        const quality_obj = response.data.quality
          ? {
              eye_visibility: response.data.quality.eyes_visibility,
              eyes_status: response.data.quality.eyes_status,
              eyes_open_metric: response.data.quality.eyes_open_metric,
              quality_metric: response.data.quality.quality_metric,
              face_occlusions_check:
                response.data.quality.face_occlusions_check,
              face_occlusions_check_score:
                response.data.quality.face_occlusions_score,
            }
          : null;
        const clientResponse = {
          transaction_id: response.id,
          code: response.code,
          feedback_code: response.message,
          quality: quality_obj,
          debug: response.debug,
          icao: response.icao_data,
        };
        const modal_txn_ref = this.dialog.open(TransactionDialogComponent, {
          data: {
            data: clientResponse,
            jsonresponse: jsonresponse,
            image: response.data.templates?.PNG
              ? "data:image/png;base64," + response.data.templates.PNG
              : response.data.templates?.JPEG
                ? "data:image/jpeg;base64," + response.data.templates.JPEG
                : undefined,
            onclose: () => {
              if (this.context_menu_service.menuValues.download) {
                new ZipModule().package(response, false).then((zipv) => {
                  saveAs(zipv, `face-templates-${new Date().getTime()}.zip`);
                });
              }

              modal_txn_ref.close();
            },
          },
        });
      })
      .catch((err: any) => {
        err = {
          code: err.code,
          responseJSON: err.responseJSON,
        };
        this.dialog.closeAll();
        const message = err.responseJSON.message;
        const clientResponse = {
          code: err.responseJSON.code ?? err.responseJSON.status,
          feedback_code: message,
          debug: err.responseJSON.debug,
        };
        setTimeout(() => {
          const modal_txn_ref = this.dialog.open(TransactionDialogComponent, {
            data: {
              data: clientResponse,
              onclose: () => {
                modal_txn_ref.close();
              },
              onretry: () => {
                this.capture();
              },
            },
          });
        }, 10);
      });
  }

  async runVideoSelfie() {
    const layoutKey =
      this.context_menu_service.menuValues.vs_phase2_layout || "BOTTOM";
    const layout: VideoSelfiePhase2Layout =
      VideoSelfiePhase2Layout[
        layoutKey as keyof typeof VideoSelfiePhase2Layout
      ] ?? VideoSelfiePhase2Layout.BOTTOM;

    const options: VideoSelfieSdkOptionsType = {
      base64EncodingFlag: Base64.NO_WRAP,
      requiredTemplates: this.context_menu_service.menuValues.templates,
      localization: this.context_menu_service.menuValues.localization,
      allowClose: true,
      enableVideoRecording:
        this.context_menu_service.menuValues.vs_enable_video_recording,
      enableVideoChallenge:
        this.context_menu_service.menuValues.vs_enable_video_challenge,
      videoChallengeText:
        this.context_menu_service.menuValues.vs_challenge_text,
      cardPosition: layout,
      transaction: {
        type: TransactionMode.CAPTURE,
      },
      asThreshold: this.context_menu_service.menuValues.as_threshold,
      captureTimeout: this.context_menu_service.menuValues.timeout * 1000,
      events: {
        ["onPhaseChanged"]: (phase: number) => {
          console.log(`Video Selfie Phase Changed: ${phase}`);
        },
      } as any,
      phase3Timeout: 15000,
      phase2Timeout: 30000
    };

    const vsSDK = new VideoSelfieSDK(options);
    this.allow_capture = false;
    return vsSDK
      .initialize()
      .then(() => {
        this.active = true;
        return vsSDK.capture().then(async (result: VideoSelfieResult) => {
          console.log("Video Selfie Result:", result);
          await this.runVideoSelfieMatches(result);
        });
      })
      .catch((err) => {
        console.error("Video Selfie Error:", err);
        const m = err && err["getLocalizedString"];
        if (m) {
          alert(err.getLocalizedString());
        } else {
          alert("Video Selfie failed: " + (err?.message || err));
        }
      })
      .finally(() => {
        this.allow_capture = true;
        this.active = false;
      });
  }

  private async matchFaces(
    label: string,
    image1: string,
    image2: string,
    useCardEndpoint: boolean = false,
  ): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    });
    const endpoint = useCardEndpoint ? "matchWithPictureId" : "matchWithSelfie";
    const body: any = {
      image: { template: image1, format: "JPEG" },
      imageToVerifyAgainst: { template: image2, format: "JPEG" },
      level: "HIGH",
    };
    try {
      const res = await this.http
        .post<any>(`${environment.url_processing}/api/v1/${endpoint}`, body, {
          headers,
        })
        .toPromise();
      console.log(`[Match] ${label} RAW RESPONSE:`, JSON.stringify(res));
      return { label, result: res };
    } catch (e) {
      console.error(`[Match] ${label} error:`, e);
      return { label, error: e };
    }
  }

  private async runVideoSelfieMatches(result: VideoSelfieResult) {
    this.dialog.open(ProgressDialogComponent, {
      disableClose: true,
      data: {
        message: "Processing matches...",
      },
    });

    const matches: { label: string; result?: any; error?: any }[] = [];
    let processResult: any = null;

    // Log image sizes for diagnostics
    const b64Size = (b64: string) =>
      b64 ? Math.round((b64.length * 3) / 4 / 1024) + "KB" : "N/A";
    console.log(
      "[VideoSelfie] Image sizes — phase1Selfie:",
      b64Size(result.phase1Selfie),
      "| phase2Selfie:",
      b64Size(result.phase2Selfie),
      "| cardCrop:",
      b64Size(result.cardCrop),
      "| cardFace:",
      b64Size(result.cardFace),
    );

    // For card matching: try cardFace first, fall back to cardCrop if cardFace is too small or missing
    const cardImage = result.cardFace || result.cardCrop;
    const cardLabel = result.cardFace ? "Card Face" : "Card Crop";

    if (result.phase1Selfie && cardImage) {
      matches.push(
        await this.matchFaces(
          `Selfie vs ${cardLabel}`,
          result.phase1Selfie,
          cardImage,
          true,
        ),
      );
    }
    if (result.phase2Selfie && cardImage) {
      matches.push(
        await this.matchFaces(
          `Video Selfie vs ${cardLabel}`,
          result.phase2Selfie,
          cardImage,
          true,
        ),
      );
    }
    if (result.phase1Selfie && result.phase2Selfie) {
      matches.push(
        await this.matchFaces(
          "Selfie vs Video Selfie",
          result.phase1Selfie,
          result.phase2Selfie,
          false,
        ),
      );
    }

    if (result.phase1Blob) {
      try {
        processResult = await this.processBlob(result.phase1Blob);
        console.log("[VideoSelfie] Process result:", processResult);
      } catch (e) {
        console.error("[VideoSelfie] Process error:", e);
        processResult = { error: e };
      }
    }

    this.dialog.closeAll();

    // Build an HTML overlay showing images + match scores
    const toImg = (b64: string, label: string) =>
      b64
        ? `<div style="text-align:center;margin:4px"><img src="data:image/jpeg;base64,${b64}" style="max-width:140px;max-height:180px;border:1px solid #ccc;border-radius:4px"><div style="font-size:11px;margin-top:2px">${label}</div></div>`
        : "";

    const extractField = (obj: any, field: string): any => {
      if (!obj || typeof obj !== "object") return undefined;
      if (obj[field] !== undefined) return obj[field];
      for (const key of Object.keys(obj)) {
        const found = extractField(obj[key], field);
        if (found !== undefined) return found;
      }
      return undefined;
    };

    const matchRows = matches
      .map((m) => {
        if (m.error)
          return `<div style="padding:8px 0;border-bottom:1px solid #eee"><b>${m.label}</b>: <span style="color:#c62828">ERROR</span></div>`;
        const r = m.result;
        const score = r?.similarityScore ?? extractField(r, "score") ?? "N/A";
        const matched = r?.possibleMatch ?? extractField(r, "match");
        const color = matched ? "#2e7d32" : "#c62828";
        return `<div style="padding:8px 0;border-bottom:1px solid #eee"><b>${m.label}</b>: <span style="color:${color};font-weight:bold">${matched ? "MATCH" : "NO MATCH"}</span> (score: ${score})<br><pre style="font-size:10px;max-height:60px;overflow:auto;margin:4px 0">${JSON.stringify(r, null, 2)}</pre></div>`;
      })
      .join("");

    let processSection = "";
    if (processResult && !processResult.error) {
      const quality = processResult.data?.quality;
      const qualityHtml = quality
        ? `<div style="margin-top:8px;font-size:12px">
            <div><b>Quality Metric:</b> ${quality.quality_metric ?? "N/A"}</div>
            <div><b>Eyes Visibility:</b> ${quality.eyes_visibility ?? "N/A"}</div>
            <div><b>Eyes Status:</b> ${quality.eyes_status ?? "N/A"}</div>
            <div><b>Eyes Open Metric:</b> ${quality.eyes_open_metric ?? "N/A"}</div>
            <div><b>Face Occlusions:</b> ${quality.face_occlusions_check ?? "N/A"} (${quality.face_occlusions_score ?? "N/A"})</div>
          </div>`
        : "";
      const templateImg = processResult.data?.templates?.PNG
        ? `<div style="text-align:center;margin-top:8px"><img src="data:image/png;base64,${processResult.data.templates.PNG}" style="max-width:120px;max-height:160px;border:1px solid #ccc;border-radius:4px"><div style="font-size:11px;margin-top:2px">Processed Template</div></div>`
        : processResult.data?.templates?.JPEG
          ? `<div style="text-align:center;margin-top:8px"><img src="data:image/jpeg;base64,${processResult.data.templates.JPEG}" style="max-width:120px;max-height:160px;border:1px solid #ccc;border-radius:4px"><div style="font-size:11px;margin-top:2px">Processed Template</div></div>`
          : "";
      processSection = `
        <div style="margin-bottom:16px;padding:12px;background:#f5f5f5;border-radius:8px">
          <h3 style="margin:0 0 8px;font-size:16px">Phase 1 Process Results</h3>
          <div style="font-size:13px">
            <div><b>Transaction ID:</b> ${processResult.id ?? "N/A"}</div>
            <div><b>Code:</b> <span style="color:${processResult.code === 200 ? "#2e7d32" : "#c62828"}">${processResult.code ?? "N/A"}</span></div>
            <div><b>Message:</b> ${processResult.message ?? "N/A"}</div>
          </div>
          ${qualityHtml}
          ${templateImg}
          <details style="margin-top:8px"><summary style="cursor:pointer;font-size:11px;color:#666">Raw Response</summary><pre style="font-size:10px;max-height:100px;overflow:auto;margin:4px 0">${JSON.stringify(processResult, null, 2)}</pre></details>
        </div>`;
    } else if (processResult?.error) {
      processSection = `
        <div style="margin-bottom:16px;padding:12px;background:#fff3f3;border-radius:8px">
          <h3 style="margin:0 0 8px;font-size:16px">Phase 1 Process Results</h3>
          <div style="color:#c62828;font-size:13px">Error: ${processResult.error?.message || JSON.stringify(processResult.error)}</div>
        </div>`;
    }

    const html = `
      <div id="vs-result-overlay" style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:99999;display:flex;align-items:center;justify-content:center">
        <div style="background:white;border-radius:12px;padding:24px;max-width:700px;width:90%;max-height:90vh;overflow-y:auto;font-family:sans-serif">
          <h2 style="margin:0 0 16px;font-size:20px">Video Selfie Results</h2>
          <div style="display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-bottom:16px">
            ${toImg(result.phase1Selfie, "Phase 1 Selfie")}
            ${toImg(result.phase2Selfie, "Phase 2 Selfie")}
            ${toImg(result.cardCrop, "Card Crop")}
            ${toImg(result.cardFace, "Card Face")}
          </div>
          ${result.recordedVideo ? `<div style="text-align:center;margin-bottom:16px"><a id="vs-video-link" href="#" style="display:inline-block;padding:10px 20px;background:#1565C0;color:white;border-radius:6px;text-decoration:none;font-size:14px">&#9654; View Recorded Video</a></div>` : ""}
          ${processSection}
          <div style="font-size:14px">${matchRows || "<div>No matches performed</div>"}</div>
          <button id="vs-result-close" style="margin-top:16px;padding:10px 24px;background:#00409E;color:white;border:none;border-radius:6px;cursor:pointer;font-size:14px;display:block;margin-left:auto;margin-right:auto">Close</button>
        </div>
      </div>`;

    const container = document.createElement("div");
    container.innerHTML = html;
    document.body.appendChild(container);
    container
      .querySelector("#vs-result-close")
      .addEventListener("click", () => container.remove());

    const videoLink = container.querySelector("#vs-video-link");
    if (videoLink && result.recordedVideo) {
      videoLink.addEventListener("click", (e) => {
        e.preventDefault();
        const blob = new Blob(
          [Uint8Array.from(atob(result.recordedVideo), (c) => c.charCodeAt(0))],
          { type: "video/webm" },
        );
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      });
    }
    (window as any).__vsMatches = matches;
    (window as any).__vsProcessResult = processResult;
    console.log("[VideoSelfie] Match Results:", matches);
  }

  capture() {
    this.runTransaction();
  }

  ngOnDestroy() {
    // Clean up all event handler subscriptions to prevent memory leaks
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
